const { fromPath } = require('falcor-path-syntax');
/**
 * Convert a Falcor string path into an array syntax path. Only suitable for leaf paths,
 * not query or routing expressions
 * @param {LeafPath<string>} path the string path expression to convert
 * @returns {LeafPath<Array>} the converted array syntax path
 * @example
 * split('fx.pairs[0].bid');
 * // => ['fx', 'pairs', 0, 'bid']
 */
function split(path) {
  return fromPath(path);
}

module.exports = split;
